import {
  IS_SHOP_UNAVAILABLE,
  UPDATE_CLOSEST_SHOPS,
  UPDATE_SHOP_IS_LOADED,
} from './types';
import { COOKIE_ORDER_TYPE, ORDER_TYPE_DELIVERY } from '../../constants';
import { getFirstShopId, getShopAndZoneData } from '../../utils';
import { listenShopData } from '../../api/firebase/firebaseOn';
import { updateAddressAndShop } from '../../utils/customer-address-and-shops';
import { Cookies } from 'react-cookie';
import store from '../store';
import { logLowError, logMediumLog } from '../../utils/logger';
import _ from 'lodash';

export const updateShop = async (address: any) => {
  const dispatch = store.dispatch;
  const getState = store.getState;
  try {
    dispatch({ type: UPDATE_SHOP_IS_LOADED, payload: false });
    const { shopId: previousShopId } = getState().shopReducer;
    const { shopId: pendingOrderShopId, orderType: pendingOrderOrderType } =
      getState().pendingOrderReducer;
    const orderType =
      pendingOrderOrderType || new Cookies().get(COOKIE_ORDER_TYPE);
    const newShopId =
      address && pendingOrderShopId
        ? pendingOrderShopId
        : await getFirstShopId();

    logMediumLog(
      `Updating shop to ${newShopId} with address ${JSON.stringify(address)}`
    );
    await logMediumLog(`Updating shop to ${newShopId}`);
    await listenShopData(
      previousShopId,
      newShopId,
      address,
      getShopAndZoneData,
      orderType
    );

    if (address && orderType === ORDER_TYPE_DELIVERY) {
      const newAddress = { ...address, deliveryPrice: undefined };
      await updateAddressAndShop(newShopId, newAddress, ORDER_TYPE_DELIVERY);
    }
  } catch (error) {
    logLowError(`Error updating shop ${error}`);
  }
};

export const updateShopIsLoaded = (
  shopIsLoaded: boolean
): { type: string; payload: boolean } => ({
  type: UPDATE_SHOP_IS_LOADED,
  payload: shopIsLoaded,
});

export const updateClosestShops = (
  shops: any[]
): { type: string; payload: any[] } => ({
  type: UPDATE_CLOSEST_SHOPS,
  payload: _.orderBy(shops, 'distance'),
});

export const isShopUnavailable = (
  shopUnavailable: boolean
): { type: string; payload: boolean } => ({
  type: IS_SHOP_UNAVAILABLE,
  payload: shopUnavailable,
});
